/**
 * Re-exports of XDM analytics helpers used across mweb modules.
 * Import from here instead of reaching into libs/utility/… directly.
 */

export { trackEvent, errorTrackEvent } from "@tm/insurance/analytics/xdm";
